import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://sabitradeng.com";

const PAGES: Record<string, { title: string; description: string }> = {
  "/": {
    title: "SabiTradeNG — Buy & Sell Online in Nigeria",
    description: "Shop from verified Nigerian sellers or start your own store — with pay on delivery, escrow-protected payments and nationwide delivery tracking.",
  },
  "/products": {
    title: "Shop Products | SabiTradeNG",
    description: "Browse beauty, fashion, home decor, food and more from verified Nigerian sellers. Pay on delivery and nationwide tracked shipping.",
  },
  "/categories": {
    title: "Shop by Category | SabiTradeNG",
    description: "Explore product categories on SabiTradeNG – fashion, beauty, home, food and electronics from trusted sellers across Nigeria.",
  },
  "/sellers": {
    title: "Verified Sellers | SabiTradeNG",
    description: "Discover trusted businesses selling on SabiTradeNG, or open your own shop and sell directly through WhatsApp.",
  },
  "/blog": {
    title: "Blog – Selling & Shopping Tips | SabiTradeNG",
    description: "Guides and tips on WhatsApp selling, online shopping and growing a small business in Nigeria from the SabiTradeNG team.",
  },
  "/how-to-use": {
    title: "How to Use SabiTradeNG",
    description: "Step-by-step guide to buying and selling on SabiTradeNG – from placing orders and paying on delivery to listing products.",
  },
  "/help-center": {
    title: "Help Center | SabiTradeNG",
    description: "Answers to common questions about orders, payments, delivery, refunds and selling on SabiTradeNG.",
  },
  "/help": {
    title: "Help Center | SabiTradeNG",
    description: "Answers to common questions about orders, payments, delivery, refunds and selling on SabiTradeNG.",
  },
  "/contact": {
    title: "Contact Us | SabiTradeNG",
    description: "Get in touch with the SabiTradeNG support team for help with orders, payments, delivery or your seller account.",
  },
  "/shipping-info": {
    title: "Shipping Information | SabiTradeNG",
    description: "Delivery options, rates and timelines for SabiTradeNG orders shipped across Nigeria, including tracked Fez deliveries.",
  },
  "/returns": {
    title: "Returns Policy | SabiTradeNG",
    description: "Learn how returns work on SabiTradeNG, including eligibility, timelines and how to start a return.",
  },
  "/refund-policy": {
    title: "Refund Policy | SabiTradeNG",
    description: "How refunds work on SabiTradeNG, including escrow-protected payments and how long refunds take to process.",
  },
  "/track-order": {
    title: "Track Your Order | SabiTradeNG",
    description: "Track your SabiTradeNG order and see live delivery status from dispatch to your doorstep.",
  },
  "/terms": {
    title: "Terms of Service | SabiTradeNG",
    description: "The terms and conditions for buying and selling on the SabiTradeNG marketplace.",
  },
  "/privacy": {
    title: "Privacy Policy | SabiTradeNG",
    description: "How SabiTradeNG collects, uses and protects your personal information.",
  },
  "/login": {
    title: "Sign In | SabiTradeNG",
    description: "Sign in to your SabiTradeNG account to track orders, manage your shop and check out faster.",
  },
  "/register": {
    title: "Create an Account | SabiTradeNG",
    description: "Join SabiTradeNG free to shop from verified sellers or start selling your products through WhatsApp.",
  },
};

/** Per-route title, description, canonical and social tags. Product and blog post pages set their own. */
export function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  const meta = PAGES[path];
  if (!meta) return null;
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
}
